import classNames, { Argument } from 'classnames'
import React from 'react'

import { isHyphenatedLocale } from '../locale/i18n'
import './Heading.scss'

const Heading = ({
  className,
  isLeftAligned,
  text,
  as: As = 'h2',
}: {
  className?: Argument
  isLeftAligned?: boolean
  text: string
  as?: React.ElementType
}) => {
  return (
    <div
      className={classNames(
        'heading',
        {
          'heading--center': !isLeftAligned,
          hyphenate: isHyphenatedLocale(),
        },
        className,
      )}
    >
      <As className="heading__primary">{text}</As>
    </div>
  )
}

export default Heading
